import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
// import { email } from '@config';
const StyledHeroSection = styled.section`
  @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;1,400&family=Poppins:wght@100;200;300;400;500&display=swap');
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 1rem 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }
  h1 span {
    color: #fff;
    font-family: var(--font-mono);
    font-size: 2rem;
    font-weight: 400;
    margin:0;
    padding:0
  }
  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  //greet users depending on time of the day
  const [Greeting, setGreeting] = useState();
  useEffect(() => {
    let time = new Date();
    let greeting = 'Good ';
    if (time.getHours() < 12) {
      greeting = greeting + 'Morning';
    } else if (time.getHours() < 18) {
      greeting = greeting + 'Afternoon';
    } else {
      greeting = greeting + 'Evening';
    }
    setGreeting(greeting);
  }, []);

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = (
    <h1>
      <span>{Greeting}</span>
      <br />
      my name is
    </h1>
  );
  const two = <h2 className="big-heading">Edward Hiuhu.</h2>;
  const three = <h3 className="big-heading">I build tools for the web.</h3>;
  const four = (
    <>
      <p>
        I’m a software engineer specializing in designing and building exceptional digital
        experiences. Currently, I’m focused on building modern frontend interfaces as well as
        redefining what's possible with Web3 tech.
      </p>
    </>
  );
  const five = (
    <a className="email-link" href="https://www.windtech.site" target="_blank" rel="noreferrer">
      Check out my Startup!
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadedown" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 2}00ms` }}>{item}</div>
              </CSSTransition>
            ))} 
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
